import { useApi } from "../../api/hooks/use-api.ts";
import { ApiMethod } from "../../api/types.ts";
import { withObjectPayload } from "../../api/payload.ts";

// Every authless action answers with a JSON object ({ success, error, message,
// errors, ... }); the payload is normalised to an object here, so callers can
// read payload.error etc. without parsing.
export const useAuthlessApi = () => {
    const { sendRequest } = useApi();

    const endpoint = process.env.REACT_APP_FPSB_PORTAL_AUTHLESS_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_AUTHLESS_TOKEN;

    // identifier: contact number or any of the contact's email addresses
    const requestPasswordReset = async (identifier:string) => {
        return sendRequest(ApiMethod.POST, endpoint + '&action=requestpasswordreset', {
            identifier: identifier
        }).then(withObjectPayload);
    };

    const updatePassword = async (identifier:string, password:string, token: string) => {
        return sendRequest(ApiMethod.POST, endpoint + '&action=resetpassword', {
            identifier: identifier,
            password: password,
            reset_token: token
        }).then(withObjectPayload);
    };

    const validateContactNumberWithDOB = async (contactNumber:string, dateOfBirth: string) => {
        return sendRequest(ApiMethod.POST, endpoint + '&action=validateContactNumberWithDOB', {
            contactNumber: contactNumber,
            dateOfBirth: dateOfBirth,
        }).then(withObjectPayload);
    };

    const setAccountPassword = async (contactNumber:string, dateOfBirth: string, password: string) => {
        return sendRequest(ApiMethod.POST, endpoint + '&action=setAccountPassword', {
            contactNumber: contactNumber,
            dateOfBirth: dateOfBirth,
            password: password,
        }).then(withObjectPayload);
    };

    const setAccountEmail = async (contactNumber:string, dateOfBirth: string, email: string, type: string) => {
        return sendRequest(ApiMethod.POST, endpoint + '&action=setAccountEmail', {
            contactNumber: contactNumber,
            dateOfBirth: dateOfBirth,
            email: email,
            type: type,
        }).then(withObjectPayload);
    };

    // OK: payload carries the access token (see RegistrationConfirm / toAccessToken).
    const activateAccount = async (token:string) => {
        return sendRequest(ApiMethod.POST, endpoint + '&action=activateAccount', {
            activate_token: token,
        }).then(withObjectPayload);
    };

    const register = async (payload:any) => {
        return sendRequest(ApiMethod.POST, endpoint + '&action=register', payload).then(withObjectPayload);
    };

    // OK: payload is { nonce }.
    const requestRegisterNonce = async () => {
        return sendRequest(ApiMethod.POST, endpoint + '&action=registerNonce', {}).then(withObjectPayload);
    };

    // CRM list values for the registration form's dropdowns, keyed by list name:
    // { <listname>: { entries: [...] } }. Entry ids are per-database, so they
    // must come from the API rather than be hardcoded.
    const getRegistrationLists = async () => {
        return sendRequest(ApiMethod.GET, endpoint + '&action=lists').then(withObjectPayload);
    };

    return { requestPasswordReset, updatePassword, validateContactNumberWithDOB, setAccountPassword, setAccountEmail, activateAccount, register, requestRegisterNonce, getRegistrationLists };
};
